import { EmployeeDto } from "./employee.dto";
import { PaginatorInfo } from "./generic.dto";
import { REQUEST_QUERY_MODE } from "./leave-request.dto";
import { PayPeriodDto } from "./pay-period.dto";

export enum WorkTimeUnit {
  HOUR = "HOUR",
  DAY = "DAY"
} 

type EmployeeWorkTime = {
  id: number;
  employeeId: number;
  payPeriodId: number;
  timeUnit: WorkTimeUnit;
  timeValue: number;
  createdAt: Date;
  modifiedAt: Date | null;
}

export class CreateEmployeeWorkTimeDto {
  employeeId!: number;
  payPeriodId!: number;
  timeUnit!: WorkTimeUnit;
  timeValue!: number;
}

export class UpdateEmployeeWorkTimeDto {
  employeeId?: number;
  payPeriodId?: number;
  timeUnit?: WorkTimeUnit;
  timeValue?: number;
}

export interface EmployeeWorkTimeDto extends EmployeeWorkTime{
  employee?: EmployeeDto,
  payPeriod?: PayPeriodDto
}

export enum EmployeeWorkTimeOrderBy {
  CREATED_AT_ASC = 'createdAt:asc',
  CREATED_AT_DESC = 'createdAt:desc',
  MODIFIED_AT_ASC = 'modifiedAt:asc',
  MODIFIED_AT_DESC = 'modifiedAt:desc',
}


export class QueryEmployeeWorkTimeDto {
  employeeId?: number;
  payPeriodId?: number;
  timeUnit?: WorkTimeUnit;
  queryMode?: REQUEST_QUERY_MODE;
  companyId?: number;
  page: number = 1;
  limit?: number;
  orderBy: EmployeeWorkTimeOrderBy = EmployeeWorkTimeOrderBy.CREATED_AT_DESC;
}

export interface EmployeeWorkTimePaginator extends PaginatorInfo<EmployeeWorkTimeDto> {}

export class UploadEmployeeWorkTimeResponse {
  successful!: {
    employeeWorkTimeId?: number;
    rowNumber?: number;
  }[];
  failed!: {
    rowNumber?: number;
    errors: {
      column: string;
      reason: string;
    }[]
  }[];
}